import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay } from "swiper/modules";
import "./Carousel.css";

const Carousel = () => {
  return (
    <div>
      <div className="container-fluid main6">
        {/* <div className='col-12 d-flex py-sm-2'></div> */}
        <div className="row k5 text-center">
          <div className="col-3"></div>
          <div className="col-6">
            <p className="p-225">OUR GALLERY</p>

            <img className="img-224" src="./image434.webp" alt="hhh" />
          </div>
          <div className="col-3"></div>
        </div>
      </div>

      <Swiper
        breakpoints={{
          1024: {
            slidesPerView: 5,
          },
          768: {
            slidesPerView: 3,
          },
          425: {
            slidesPerView: 2,
          },
          375: {
            slidesPerView: 2,
          },
          320: {
            slidesPerView: 2,
          },
        }}
        modules={[Autoplay]}
        loop={true}
        spaceBetween={20}
        slidesPerView={5}
        autoplay={true}
      >
        <div className="swiper-container">
          <SwiperSlide>
            <img className="imgc" src="./imgc-1.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-2.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-3.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-4.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-5.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-5.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-5.png" alt="hhh" />
          </SwiperSlide>
          <SwiperSlide>
            <img className="imgc" src="./imgc-5.png" alt="hhh" />
          </SwiperSlide>
        </div>
      </Swiper>
      <div className="container-fluid main16">
        <div className="col-12 d-flex py-4"></div>
        <div className="row  ">
          <div className="col-3"></div>
          <div className="col-6-sm text-center ">
            <a href="/gallery">
              <button className="btn" type="button">
                <p className="pp-6">See Full Gallery</p>
              </button>
            </a>
          </div>
          <div className="col-3"></div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
